// Format a number string with thousand separators (Indonesian style).
export function toPrice(value) {
    return new Intl.NumberFormat('id-ID').format(value);
}

// Compare two numeric operands with a given operator, without eval().
// Throws on blank or non-numeric operands so callers can treat invalid
// ranges the same way they treated eval() syntax errors.
export function compareValues(operator, left, right) {
    if (String(left).trim() === '' || String(right).trim() === '') {
        throw new TypeError('Comparison operand is empty');
    }
    const a = Number(left);
    const b = Number(right);
    if (Number.isNaN(a) || Number.isNaN(b)) {
        throw new TypeError('Comparison operand is not a number');
    }
    switch (operator) {
        case '>':
            return a > b;
        case '>=':
            return a >= b;
        case '<':
            return a < b;
        case '<=':
            return a <= b;
        case '=':
            return a === b;
        default:
            throw new TypeError('Invalid comparison operator: ' + String(operator));
    }
}

const bulans = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Agu',
    'Sep',
    'Okt',
    'Nov',
    'Des',
]

export function dateFormatIndo(s) {
    if (s.length < 10) return "Invalid Date"

    const tahun = s.substr(0, 4)
    const bulan = s.substr(5, 2)
    const tanggal = s.substr(8, 2)

    return `${tanggal} ${bulans[Number.parseInt(bulan, 10)]} ${tahun}`
}

export function dateOnlyHourMinute(s) {
    if (s.length < 5) return "Invalid Date"
    return s.substr(0, 5)
}